import { useContext } from 'react'
import AdsContext from './AdsProvider'

const useAds = () => {
    return useContext(AdsContext)
}
export default useAds
